export default function formatLead(input) {
  switch (input) {
    case 'status':
      return 'Trạng thái'
    case 'appointmentSet':
      return 'Đã đặt lịch hẹn'
    case 'notSeen':
      return 'Chưa hỗ trợ'
    case 'inProgress':
      return 'Đang hỗ trợ'
    case 'closed':
      return 'Đã đóng'
    case '':
      return ''
    default:
      return input
  }
}
